import React from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";

const PlayerLayout: React.FC = () => {
  return (
    <Box height="100%" sx={{ display: "flex" }}>
      <Box height="100%" width="100%">
        <Outlet />
      </Box>
    </Box>
  );
};

export default PlayerLayout;
